module.exports = __webpack_public_path__ + "media/images/common/login_btn_ov-01ed9a2ea1c2b71938a8386021edbfae.gif";